// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3jnzY","info":"UpdateTermsInfo_info__2WspY"};